import { render, staticRenderFns } from "./ShiftWorkerSelector.vue?vue&type=template&id=349d97f1&"
import script from "./ShiftWorkerSelector.vue?vue&type=script&lang=js&"
export * from "./ShiftWorkerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports